import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1107" data-mp="y0fqb79zkpi5">
      <Navbar data-id="element-1108" data-mp="y0yznzlkm5kk" />
      <main className="flex-1" data-id="element-1109" data-mp="xycolpzh17xl">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-1110" data-mp="t24dcnoe9yvp">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1111" data-mp="17q8s5gkbtq97">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-1112" data-mp="12zsblnl7loim">
              Contact Us
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-1113" data-mp="f963jwb7g48m">
              We're here to help. Get in touch with our team for support,
              inquiries, or feedback.
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-1114" data-mp="15dm7391qj3bu">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1115" data-mp="19fh8senkviq5">
            {/* Contact Info */}
            <div className="space-y-8" data-id="element-1116" data-mp="1e8ab6vvkqez2">
              <div data-id="element-1117" data-mp="1j6twcu2cfmqd">
                <h2 className="text-2xl font-bold text-text-dark mb-4" data-id="element-1118" data-mp="1j73ejvh5cpli">
                  Get in Touch
                </h2>
                <p className="text-text-muted leading-relaxed" data-id="element-1119" data-mp="mhw1zcyi9qtq">
                  Whether you're a facility looking to fill shifts or a
                  healthcare professional seeking opportunities, our team is
                  ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-1120" data-mp="10hdoflobwrzx">
                <div className="flex items-start gap-4" data-id="element-1121" data-mp="10dzik3ggi0nq">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-1122" data-mp="26vmmg9wab0d2">
                    <PhoneIcon className="w-6 h-6 text-medical-blue" data-id="element-1123" data-mp="2bto54tpssxo0" />
                  </div>
                  <div data-id="element-1124" data-mp="1m5sibrk3a2jm">
                    <h3 className="font-bold text-text-dark" data-id="element-1125" data-mp="1m96l30wo0drl">Phone</h3>
                    <p className="text-text-muted mt-1" data-id="element-1126" data-mp="1h7qyh4eu9z73">1-800-555-1234</p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-1127" data-mp="1w5t19ce1qgna">
                      Available 24/7 for urgent staffing needs
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-1128" data-mp="13g2q9c7pnuve">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-1129" data-mp="13ej5p9f0uxnt">
                    <MailIcon className="w-6 h-6 text-medical-blue" data-id="element-1130" data-mp="1d6f7augbh5ws" />
                  </div>
                  <div data-id="element-1131" data-mp="18fypky5gqy4m">
                    <h3 className="font-bold text-text-dark" data-id="element-1132" data-mp="18fozlakf4qyx">Email</h3>
                    <p className="text-text-muted mt-1" data-id="element-1133" data-mp="kqe7sil1q6wx">
                      support@carenomad.com
                    </p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-1134" data-mp="fs2zicaeg4gt">
                      We typically respond within 2 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-1135" data-mp="2w5v992ampu78">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-1136" data-mp="2w7g4ku4rph65">
                    <MapPinIcon className="w-6 h-6 text-medical-blue" data-id="element-1137" data-mp="2mfjs2e1xpoie" />
                  </div>
                  <div data-id="element-1138" data-mp="2md7fyhiuy8d9">
                    <h3 className="font-bold text-text-dark" data-id="element-1139" data-mp="3a4ml0i20r3s7">Headquarters</h3>
                    <p className="text-text-muted mt-1" data-id="element-1140" data-mp="3f47gujlw6w0p">
                      123 Healthcare Ave, Suite 400
                    </p>
                    <p className="text-text-muted" data-id="element-1141" data-mp="3157wvp9br5av">Toronto, ON M5V 3A8</p>
                    <p className="text-sm font-semibold text-medical-blue mt-2" data-id="element-1142" data-mp="355rpqgmv7mr7">
                      Ontario THA License #: 12345678
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-float border border-gray-100 p-8" data-id="element-1143" data-mp="1torzrrnzpk0c">
              <h3 className="text-xl font-bold text-text-dark mb-6" data-id="element-1144" data-mp="2a03vri9ful7l">
                Send us a message
              </h3>

              {submitted ? <div className="bg-soft-teal rounded-xl p-8 text-center" data-id="element-1145" data-mp="207g22wdr8xd3">
                  <div className="w-16 h-16 bg-accent-teal rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1146" data-mp="1v9ehg70okpzi">
                    <SendIcon className="w-8 h-8 text-white" data-id="element-1147" data-mp="2sx52b7in4tdn" />
                  </div>
                  <h4 className="text-xl font-bold text-text-dark mb-2" data-id="element-1148" data-mp="2nxabt52s25t4">
                    Message Sent!
                  </h4>
                  <p className="text-text-muted" data-id="element-1149" data-mp="2ixe7f4q64cd1">
                    Thank you for reaching out. A member of our team will get
                    back to you shortly.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-medical-blue font-semibold hover:underline" data-id="element-1150" data-mp="17klgtx945tyk">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1151" data-mp="3j7xeb6h9e447">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1152" data-mp="3o68nrg3n6clw">
                    <div data-id="element-1153" data-mp="3o3vxmfnqcvxr">
                      <label htmlFor="firstName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1154" data-mp="3swfbldqbxt33">
                        First Name
                      </label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Jane" data-id="element-1155" data-mp="6nxlenxkiaid" />
                    </div>
                    <div data-id="element-1156" data-mp="2hi21rcseve62">
                      <label htmlFor="lastName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1157" data-mp="2hjmnccwqzmrs">
                        Last Name
                      </label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Doe" data-id="element-1158" data-mp="3ttdziemxd16w" />
                    </div>
                  </div>

                  <div data-id="element-1159" data-mp="gcxz8t6lvgi7">
                    <label htmlFor="email" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1160" data-mp="ggc0fy3j9jo2">
                      Email Address
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="jane@example.com" data-id="element-1161" data-mp="ldklc6g2g1t0" />
                  </div>

                  <div data-id="element-1162" data-mp="10017yge739o7">
                    <label htmlFor="subject" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1163" data-mp="zz853qicx4bc">
                      Subject
                    </label>
                    <select id="subject" className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors bg-white" data-id="element-1164" data-mp="r0w6b17c707t">
                      <option data-id="element-1165" data-mp="398pjc3sh5j9">I'm a facility looking for staff</option>
                      <option data-id="element-1166" data-mp="3c4nv1jjtw88">
                        I'm a healthcare worker looking for shifts
                      </option>
                      <option data-id="element-1167" data-mp="nredwofgti1o">General Inquiry</option>
                      <option data-id="element-1168" data-mp="nos92wjylgn5">Support</option>
                    </select>
                  </div>

                  <div data-id="element-1169" data-mp="ipp3nb02h8en">
                    <label htmlFor="message" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1170" data-mp="dsp0b7ulqjr8">
                      Message
                    </label>
                    <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors resize-none" placeholder="How can we help you?" data-id="element-1171" data-mp="4t26p8846i8q"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-medical-blue hover:bg-medical-blue-dark text-white font-bold py-3.5 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-1172" data-mp="3h84802fich97">
                    <SendIcon className="w-4 h-4" data-id="element-1173" data-mp="1wr3f4cumiv3l" />
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </main>
      <StickyFooter data-id="element-1174" data-mp="26q2l1no08cmw" />
    </div>;
}